import { IRevisionHistory } from '@brighterion/types/revisionHistory';
import { StateCreator } from 'zustand';

export const initialRevisionHistoryState: IRevisionHistory[] = [];

export interface RevisionHistorySlice {
    revisionHistory: IRevisionHistory[];
    setRevisionHistory: (data: IRevisionHistory[]) => void;
}

export const createRevisionHistorySlice: StateCreator<RevisionHistorySlice, [], [], RevisionHistorySlice> = (set) => ({
    revisionHistory: [...initialRevisionHistoryState],
    setRevisionHistory: (revisionHistoryData: IRevisionHistory[]) =>
        set(() => ({ revisionHistory: revisionHistoryData }))
});
